import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useSelector } from 'react-redux';

function GlobalSnackbar() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  
  // Get the snackbar state from Redux
  const snackbarState = useSelector(state => state.snackbar);
  
  useEffect(() => {
    // Check if we have a message and timestamp
    if (snackbarState?.message && snackbarState?.timestamp) {
      setMessage(snackbarState.message);
      setSeverity(snackbarState.severity || 'success');
      // Close any existing snackbar first
      setOpen(false);
      // Open the new snackbar after a tiny delay
      setTimeout(() => {
        setOpen(true);
      }, 100);
    }
  }, [snackbarState?.message, snackbarState?.timestamp]);
  
  const handleClose = () => {
    setOpen(false);
  };
  
  return (
    <Snackbar
      open={open}
      autoHideDuration={message === 'Account created! Please check your email to verify your account before signing in.' ? 10000 : 5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{
          width: '100%',
          ...(message === 'Account created! Please check your email to verify your account before signing in.'
            ? {
                fontSize: '16px',
                fontWeight: 500,
                padding: '14px 18px',
                borderRadius: '12px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                '& .MuiAlert-icon': { fontSize: 24 },
              }
            : {}),
          ...(severity === 'success'
            ? {
                backgroundColor: '#129de8',
                color: '#fff',
                '& .MuiAlert-icon': { color: '#fff' },
              }
            : {
                backgroundColor: '#B53737',
                color: '#fff',
                '& .MuiAlert-icon': { color: '#fff' },
              }
          ),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default GlobalSnackbar; 